
    import Component from "vue-class-component"
    import {Prop} from "vue-property-decorator";
    import Vue from 'vue';
    import {EndorsementStatus} from "@/api-client";
    import translateEndorsementStatus from "@/features/endorsements/components/EndorsementStatusTranslator";

    @Component
    export default class EndorsementStatusBadge extends Vue {
        @Prop({ required: true })
        status!: EndorsementStatus;

        get text(): string {
            return translateEndorsementStatus(this.status);
        }

        get badgeClass() {
            return { 'badge badge-success': this.status === EndorsementStatus.Valid,
                'badge badge-warning': this.status === EndorsementStatus.Suspended,
                'badge badge-danger': this.status === EndorsementStatus.Invalid }
        }
    }
